import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const styles = theme => ({
  input: {
    display: "none"
  },
  editButton: {
    marginTop: theme.spacing(1),
    textTransform: "none"
  }
});

export const FileInput = withStyles(styles)(props => {
  const { children, accept, id, onChange, classes } = props;
  return (
    <div>
      <input
        accept={accept}
        id={id}
        type="file"
        display="none"
        className={classes.input}
        onChange={event => onChange(event.target.files[0])}
      />
      <label htmlFor={id}>
        <Button
          variant="contained"
          component="span"
          color="primary"
          className={classes.editButton}
        >
          {children}
        </Button>
      </label>
    </div>
  );
});
